import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import mockData from '../mocks/mapData.json';

const DEFAULT_USE_MOCK = process.env.REACT_APP_USE_MOCK_MAP === 'true';

/**
 * 全国スポット一覧取得フック
 *
 * - useMock=true (or REACT_APP_USE_MOCK_MAP=true): src/mocks/mapData.json を返す（開発用）
 * - それ以外: Firestoreの /mapSpots コレクションを全件取得する
 *
 * @param {{ useMock?: boolean }} options
 * @returns {{ spots: Array, loading: boolean, error: Error | null }}
 */
const useMapSpots = ({ useMock = DEFAULT_USE_MOCK } = {}) => {
  const [spots, setSpots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    // ── モックモード ──────────────────────────────────────────
    if (useMock) {
      const data = mockData.spots.filter((s) => s.isActive !== false);
      setSpots(data);
      setLoading(false);
      return;
    }

    // ── 本番モード（Firestore） ───────────────────────────────
    let cancelled = false;

    const fetchSpots = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'mapSpots'));
        if (cancelled) return;
        const data = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((s) => s.isActive !== false);
        setSpots(data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchSpots();
    return () => {
      cancelled = true;
    };
  }, [useMock]);

  return { spots, loading, error };
};

export default useMapSpots;
